import { IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar } from '@ionic/react';
import { useParams } from 'react-router';
import RegistrerenForm from '../components/RegistrerenForm';

const Registreren: React.FC = () => {
  return <RegistrerenForm />;
};

export default Registreren;
